import { NgModule } from '@angular/core';

import { ProfileListComponent } from './profile-list/profile-list.component';
import { ProfileDialogComponent } from './profile-dialog/profile-dialog.component';
import { SharedModule } from '@app/shared';
import { ProfileSelectComponent } from './profile-select/profile-select.component';
import { ApplicationsModule } from '../applications';

@NgModule({
  declarations: [
    ProfileListComponent,
    ProfileDialogComponent,
    ProfileSelectComponent
  ],
  imports: [
    SharedModule,
    ApplicationsModule
  ],
  exports: [
    ProfileSelectComponent
  ]
})
export class ProfilesModule { }
